import { all, fork, take } from 'redux-saga/effects';

import { history } from '../../services';
import { navigate, navigateBack } from './actions';

function* watchNavigate() {
  while (true) {
    const { payload } = yield take(navigate);
    history.push(payload.pathname);
  }
}

function* watchNavigateBack() {
  while (true) {
    yield take(navigateBack);
    history.goBack();
  }
}

// TODO check is it working after history lib update!!
// function* watchLockNavigation() {
//   while (true) {
//     const { payload } = yield take('LOCK_NAVIGATION');

//     // THIS SHT DOESN'T PREVENT BROWSER BACK/FORWARD BUTTON NAVIGATION
//     // MAYBE AFTER HISTORY UPGRADE...
//     // https://github.com/ReactTraining/history/blob/v3.3.0/docs/ConfirmingNavigation.md
//     const unsubscribe = history.listenBefore(loc => {
//       console.log('[NAV] LOCKED');
//       return false;
//     });

//     yield take('UNLOCK_NAVIGATION');
//     console.log('[NAV] unlocked');
//     yield call(unsubscribe);
//   }
// }

// TODO decouple from components
// function* routeChannelSaga() {
//   const routeChannel = eventChannel(emitter => {
//     const unListen = history.listen(location => {
//       emitter({ location });
//     });
//     return () => {
//       unListen && unListen();
//     };
//   });
//   try {
//     while (true) {
//       let message = yield take(routeChannel);
//       console.log(`[route] `, message);
//     }
//   } finally {
//     console.log('[route] terminated');
//   }
// }

export function* routerSaga() {
  yield all([
    fork(watchNavigate),
    fork(watchNavigateBack),
    // fork(watchLockNavigation)
  ]);
}
